import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=2c552930&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=2c552930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c552930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c552930')) {
      api.createRecord('2c552930', component.options)
    } else {
      api.reload('2c552930', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=2c552930&scoped=true&", function () {
      api.rerender('2c552930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Menu.vue"
export default component.exports